import { render, staticRenderFns } from "./PromotionProduct.vue?vue&type=template&id=ca96eb50&"
import script from "./PromotionProduct.vue?vue&type=script&lang=js&"
export * from "./PromotionProduct.vue?vue&type=script&lang=js&"
import style0 from "./PromotionProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports